module.exports = __webpack_public_path__ + "img/museu-masp.80d6546c.jpg";